// extracted by mini-css-extract-plugin
export default {"error":"ErrorDublon_error_d94ea","caption":"ErrorDublon_caption_c6950","message":"ErrorDublon_message_b1dfe"};